import React from 'react'
import s from '../../css/profile/profileUsage.module.css'
import { toBars } from './usageBars'

const TITLE = 'Запросы за последние 3 дня'

const ProfileUsage = ({ usageData, isUsageError }) => {
	if (isUsageError) {
		return (
			<section className={s.card}>
				<h3 className={s.title}>{TITLE}</h3>
				<p className={s.message}>Не удалось загрузить</p>
			</section>
		)
	}

	if (!usageData) {
		return (
			<section className={s.card}>
				<h3 className={s.title}>{TITLE}</h3>
				<p className={s.message}>Загрузка…</p>
			</section>
		)
	}

	return (
		<section className={s.card}>
			<h3 className={s.title}>{TITLE}</h3>
			<ul className={s.bars} aria-label='Запросы по дням'>
				{toBars(usageData.days).map(bar => (
					<li key={bar.date} className={s.day}>
						<span className={s.value}>{bar.requests}</span>
						<div className={s.track}>
							<div
								className={s.fill}
								style={{ height: `${bar.heightPercent}%` }}
							/>
						</div>
						<span className={s.label}>{bar.label}</span>
					</li>
				))}
			</ul>
		</section>
	)
}

export default ProfileUsage
